import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center ${className}`} data-id="element-15">
      <h1 className="text-6xl font-black text-white tracking-tight drop-shadow-md select-none" style={{
      fontFamily: '"Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif'
    }} data-id="element-16">
        GOFish
      </h1>
    </div>;
}